import React, { useMemo } from 'react';
import { gates_dictionary } from '../../static/gates_dictionary';
import { FocusedBody } from './FocusedBody';

// ворота показываем через их центр, поэтому зум зависит от размера центра:
// чем центр крупнее, тем меньше можно приближать
const centerZoom = {
  "HD": 2.4,
  "AA": 2.2,
  "TT": 2,
  "GC": 2.4,
  "HT": 2.6,
  "SL": 2,
  "SN": 2.2,
  "SP": 2.2,
  "RT": 2,
}

export default function GateFocused({
  style = {},
  design,
  gateId,
  size = 'md',
  highlighted,
  numbers = true,
  width = '12em',
  height = '12em',
  zoom,
}) {

  const gate = parseInt(gateId);

  const center = gates_dictionary[gate] && gates_dictionary[gate]['center'];

  const highlightedCenters = useMemo(() => {
    if (highlighted && highlighted.length) return highlighted;
    return center ? [center] : [];
  }, [highlighted, center]);

  const highlightedGate = useMemo(() => [gate], [gate]);

  return (
    <FocusedBody
      design={design}
      style={style}
      size={size}
      width={width}
      height={height}
      numbers={numbers}
      zoom={zoom || centerZoom[center] || 1}
      highlightedCenters={highlightedCenters}
      highlightedGate={highlightedGate}
    />
  )
}
